import React, { Component } from "react";
import { Route, Redirect, Switch, withRouter } from "react-router-dom";

import LoginForm from "./components/loginForm";
import RegisterForm from "./components/registerForm";
import ProfileForm from "./components/profileForm";
import AllEvents from "./components/allEvents";
import MyEvents from "./components/myEvents";
import SystemEvents from "./components/systemEvents";

import Logout from "./components/logout";
import EventForm from "./components/eventForm";
import ImagesFull from "./components/common/imagesFull"; 

import NotFound from "./components/notFound";


import { Provider } from "react-redux";
import configureStore from "./store/configureStore";

import { PersistGate } from "redux-persist/integration/react";

import NavBar from "./components/navBar";

import "./App.css";


const { store, persistor } = configureStore();

class App extends Component {
  state = {prevPath: null};

  componentWillReceiveProps(nextProps){
    if (nextProps.location !== this.props.location)
      this.setState({prevPath: this.props.location});
  }

  render() {
    
    const currentPath = this.props.location? this.props.location.pathname: "";

    const fullScreenRoutes = ['/imagesFull']


    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <React.Fragment >
            {/* <ToastContainer /> */}
            {!fullScreenRoutes.includes(currentPath)?<NavBar/>: null}
            <main
              className="container"
              // style={{ backgroundColor: "#F0F0F0" }}
            >
              <Switch>
                <Route path="/imagesFull" component={ImagesFull} />
                <Route path="/all-events" render={(props) => <AllEvents {...props} prevPath={this.state.prevPath} />} />
                {/* <Route path="/all-events" component={AllEvents} /> */}
                <Route path="/profile" component={ProfileForm} />
                <Route path="/my-events" render={(props) => <MyEvents {...props} prevPath={this.state.prevPath} />} />
                <Route path="/system-events" render={(props) => <SystemEvents {...props} prevPath={this.state.prevPath} />} />
                <Route path="/events/form/:id" component= {EventForm}/>
                <Route path="/not-found" component={NotFound} />
                <Route path="/register" component={RegisterForm} />
                <Route path="/login" component={LoginForm} />
                <Route path="/logout" component={Logout} />
                <Redirect exact from="/" to="/home" />
                <Redirect exact from="/home" to="/all-events" />
                <Redirect to="/not-found" />
              </Switch>
            </main>
          </React.Fragment>
        </PersistGate>
      </Provider>
    );
  }
}

export default withRouter(App);
